module.exports = __webpack_public_path__ + "/images/video-explicativo-cover.31e0723.jpg";